'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  LoginSuccess: {
    displayName: 'LoginSuccess'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/containers/LoginSuccess/LoginSuccess.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var LoginSuccess = _wrapComponent('LoginSuccess')((_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}, authActions), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LoginSuccess, _Component);

  function LoginSuccess() {
    (0, _classCallCheck3.default)(this, LoginSuccess);
    return (0, _possibleConstructorReturn3.default)(this, (LoginSuccess.__proto__ || (0, _getPrototypeOf2.default)(LoginSuccess)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoginSuccess, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          logout = _props.logout;

      return user && _react3.default.createElement(
        'div',
        { className: 'container' },
        _react3.default.createElement(
          'h1',
          null,
          'Login Success'
        ),
        _react3.default.createElement(
          'div',
          null,
          _react3.default.createElement(
            'p',
            null,
            'Hi, ',
            user.name,
            '. You have just successfully logged in, and were forwarded here by ',
            _react3.default.createElement(
              'code',
              null,
              'componentWillReceiveProps()'
            ),
            ' in ',
            _react3.default.createElement(
              'code',
              null,
              'App.js'
            ),
            ', which is listening to the auth reducer via redux ',
            _react3.default.createElement(
              'code',
              null,
              '@connect'
            ),
            '. How exciting!'
          ),
          _react3.default.createElement(
            'p',
            null,
            'The same function will forward you to ',
            _react3.default.createElement(
              'code',
              null,
              '/'
            ),
            ' should you chose to log out. The choice is yours...'
          ),
          _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
              'button',
              { className: 'btn btn-danger', onClick: logout },
              _react3.default.createElement('i', { className: 'fa fa-sign-out' }),
              ' ',
              'Log Out'
            )
          )
        )
      );
    }
  }]);
  return LoginSuccess;
}(_react2.Component), _class2.propTypes = {
  user: _react2.PropTypes.object,
  logout: _react2.PropTypes.func
}, _temp)) || _class));

exports.default = LoginSuccess;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/LoginSuccess/LoginSuccess.js
// module id = 1210
// module chunks = 0